import BaseObject from "../BaseObject";
import * as BABYLON from "@babylonjs/core";

export default class MeshObject extends BaseObject
{
    constructor(scene, name, options, node)
    {
        super(scene, name, options);

        if (!this.defaultState.children)
        {
            this.defaultState.children = {};
        }
        this.currentState = {children: {}};
        this.children = [];

        this.node = node;
    }

    initChilds()
    {
        this.children = [];
        let children = this.node.getChildren();
        if (children)
        {
            for (let i = 0; i < children.length; i++)
            {
                this.children.push(
                    new MeshObject(this.scene, children[i].id,
                        (this.defaultState.children[children[i].id] ? this.defaultState.children[children[i].id] : {}),
                        children[i]
                    )
                );
            }
        }
    }

    getChildByName(name)
    {
        for (let key in this.children)
        {
            if (this.children.hasOwnProperty(key) && this.children[key].name === name )
            {
                return this.children[key];
            }
        }

        return false;
    }

    runStateFunctions(newState)
    {
        // Unter Objekte anzeigen / verstecken
        if (newState.children)
        {
            for (let child in newState.children)
            {
                if (newState.children.hasOwnProperty(child) && this.currentState.children[child] !== newState.children[child])
                {
                    let childObject = this.getChildByName(child);
                    if (childObject)
                    {
                        childObject.setState(newState.children[child]);
                    }
                }
            }
        }

        super.runStateFunctions(newState);
    }

    fade(value)
    {
        if (this.node && this.currentState.fade)
        {
            // Bei Texturen mit Alpha geht das Fade nicht richtig.
            // Als fix wird hier die gleiche Texture auch als opacityTexture benutzt.
            // objects with transparent alpha used for alpha testing cannot have alpha blending enabled
            // Source https://www.html5gamedevs.com/topic/17242-fade-object-with-alpha-texture/?tab=comments#comment-97103
            let albedoTexture = this.node.material.albedoTexture;
            if (albedoTexture && albedoTexture.hasAlpha)
            {
                this.node.material.opacityTexture = this.node.material.albedoTexture;
            }

            if (!this.fadeBehavior)
            {
                this.fadeBehavior = new BABYLON.FadeInOutBehavior();
                this.fadeBehavior.fadeInTime = 350;  //350;
                this.node.addBehavior(this.fadeBehavior);
            }

            this.fadeBehavior.fadeIn(value);
        }
    }

    show()
    {
        super.show();
        this.fade(true);
    }

    hide()
    {
        // Wenn das Objekt fade benutzt verstecken wir es nicht, sonst ist es direkt weg.
        if (!this.currentState.fade)
        {
            super.hide();
        }
        this.fade(false);
    }
}